import {
  BookingPackageType,
  BookingProductType,
  BookingState,
  isBookingProductTypePackage
} from '@products/models/booking.model';
import { AppConstants } from '@shared/app-constants';
import {
  findPackageIndex,
  isValidProductType,
  validateProductTypes
} from '@store/products/booking/product/product-booking.reducer';
import { cloneDeep } from 'lodash';

/**
 * Set package product in booking list
 * @description Set package product in booking list
 * @param state
 * @param props
 * @returns State
 */
export const setPackageProductInBookingList = (
  state: BookingState,
  props: { bookingProductTypes: BookingProductType[] }
) => {
  const cloneStateProductsList: BookingProductType[] = cloneDeep(state.list);
  const bookedPackageTypes: BookingPackageType[] = cloneDeep(props.bookingProductTypes) as BookingPackageType[];

  if (bookedPackageTypes.length) {
    bookedPackageTypes.forEach((setProductType) => {
      if (isBookingProductTypePackage(setProductType)) {
        const packageBookingIndex = findPackageIndex(setProductType, cloneStateProductsList);
        const validatedSetPackageProductType = validateProductTypes(setProductType);
        const isPackageProductTypeValid = isValidProductType(validatedSetPackageProductType);

        if (packageBookingIndex === AppConstants.INDEX_NOT_FOUND) {
          if (isPackageProductTypeValid) {
            cloneStateProductsList.push(validatedSetPackageProductType);
          }
        } else {
          if (isPackageProductTypeValid) {
            cloneStateProductsList[packageBookingIndex] = validatedSetPackageProductType;
          } else {
            cloneStateProductsList.splice(packageBookingIndex, 1);
          }
        }
      }
    });

    return {
      ...state,
      list: cloneStateProductsList
    };
  }

  return state;
};

/**
 * Remove package product from booking list
 * @description Remove package product from booking list
 * @param state
 * @param props
 * @returns State
 */
export const removePackageProductInBookingList = (
  state: BookingState,
  props: { bookingProductTypes: BookingProductType[] }
) => {
  const cloneStateProductsList: BookingProductType[] = cloneDeep(state.list);
  const removedProductTypes: BookingPackageType[] = cloneDeep(props.bookingProductTypes) as BookingPackageType[];

  if (removedProductTypes.length) {
    removedProductTypes.forEach((removedProductType) => {
      if (isBookingProductTypePackage(removedProductType)) {
        const packageBookingIndex = findPackageIndex(removedProductType, cloneStateProductsList);

        if (packageBookingIndex !== AppConstants.INDEX_NOT_FOUND) {
          cloneStateProductsList.splice(packageBookingIndex, 1);
        }
      }
    });

    return {
      ...state,
      list: cloneStateProductsList
    };
  }

  return state;
};
